module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_30_40.fdd48109.png";